import { render } from "./OfflinejobsView.vue?vue&type=template&id=67288c8d"
import script from "./OfflinejobsView.vue?vue&type=script&lang=js"
export * from "./OfflinejobsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__